t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectInput
        :question="$t('project.question')"
        :selections="[
          {
            image: require('@/assets/construct.svg'),
            name: $t('project.new'),
            value: 'new'
          },
          {
            image: require('@/assets/renovation.svg'),
            name: $t('project.renovation'),
            value: 'renovation'
          }
        ]"
        :selected-value="projectType"
        :clicked-callback="onSelect"
      ></SelectInput>
    </div>
  </div>
</template>

<script>
import SelectInput from "../../components/SelectInput";
import { mapMutations } from "vuex";
import CalculatorHeading from "../../components/CalculatorHeading";
import { getStepIndex, getNextStepUrl } from "@/utils/steps.js";

export default {
  name: "Project",
  components: { CalculatorHeading, SelectInput },
  data() {
    return {
      step: getStepIndex("project"),
      projectType: this.$store.state.data.projectType
    };
  },
  methods: {
    ...mapMutations(["updateProjectType"]),
    onSelect(value) {
      this.projectType = value;
      this.updateProjectType(value);
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/_variables.scss";
h4 {
  color: $color-primary;
}
</style>
